import { Controller } from 'stimulus';

let slideIndex = 1;

export default class extends Controller {
  static targets = ['bottomActions', 'topActions', 'slides', 'next', 'skip', 'dashboard'];

  connect() {
    this.showSlides(slideIndex);
  }

  nextSlide() {
    this.showSlides(slideIndex += 1);
  }

  showSlides(slideNumber) {
    $(this.slidesTargets).css({'display': 'none'})
    this.slidesTargets[slideIndex - 1].style.display = 'block';

    if (slideNumber == 7) {
      $(this.bottomActionsTarget).removeClass('d-flex').addClass('d-none');
      this.topActionsTarget.classList.add('d-flex');
    } else {
      $(this.bottomActionsTarget).addClass('d-flex').removeClass('d-none');
      this.topActionsTarget.classList.remove('d-flex');
    }

    if (slideNumber === this.slidesTargets.length) {
      $(this.nextTarget).addClass('d-none').removeClass('d-flex');
      $(this.skipTarget).addClass('d-none');
      $(this.dashboardTarget).addClass('d-flex').removeClass('d-none');;
    }
  }
}
